<template>
<div class="row" style="margin-top: 42px;">
        <div class="col-md-3">

          <!-- Profile Image -->
          <div class="box box-primary p-3">
            <div class="box-header">
            </div>
            <div class="box-body box-profile">
              <!-- <img class="profile-user-img img-responsive img-circle" src="../../assets/img/default.png" alt="User profile picture"> -->
              <img v-if="userInfo.profile_picture !='' && userInfo.profile_picture !=null" :src="`${userInfo.profile_picture}`" class="profile-user-img img-responsive img-circle">
              <img v-if="userInfo.profile_picture =='' || userInfo.profile_picture ==null" src="../../assets/img/org-default.png" class="profile-user-img img-responsive img-circle">
              <h3 class="profile-username text-center">{{userInfo.organization}}</h3>

              <!-- <p class="text-muted text-center">Software Engineer</p> -->

              <!-- <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <b>Followers</b> <a class="pull-right">1,322</a>
                </li>
                <li class="list-group-item">
                  <b>Following</b> <a class="pull-right">543</a>
                </li>
                <li class="list-group-item">
                  <b>Friends</b> <a class="pull-right">13,287</a>
                </li>
              </ul> -->
              <div class="row">
                <div class="col-md-6">
                  <a v-bind:href="''+form.orgwebsiteurl+''" target="_blank" class="btn btn-success btn-block"><i class="fa fa-globe" aria-hidden="true"></i> Website</a>
                </div>
                <div class="col-md-6">
                  <a href="#" class="btn btn-primary btn-block"><i class="fa fa-linkedin" aria-hidden="true"></i> Linkedin</a>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->

          <!-- About Me Box -->
          <div class="box box-primary p-3">
            <!-- <div class="box-header with-border">
              <h3 class="box-title">Contact</h3>
            </div> -->
            <!-- /.box-header -->
            <div class="box-body">
              <strong>Contact</strong>
              <hr>
              <p><i class="fa fa-phone margin-r-5" aria-hidden="true"></i> {{userInfo.mobile_number}}</p>

              <p class="over-len"><i class="fa fa-envelope-o margin-r-5" aria-hidden="true"></i> {{userInfo.user_email}}</p>
              <!-- <strong>Time Zone</strong>
              <hr>
              <p><i class="fa fa-map-marker margin-r-5"></i> India</p> -->
              <strong>Location</strong>
              <hr>
              <p><i class="fa fa-map-marker margin-r-5"></i> {{form.country.name}}</p>
              <strong> Analytics</strong>
              <hr>
              <!-- <vc-donut
    background="white" foreground="grey"
    :size="150" unit="px" :thickness="25"
    has-legend legend-placement="top"
    :sections="sections" :total="100"
    :start-angle="0" :auto-adjust-text-size="false"
    @section-click="handleSectionClick">
    <h3>75%</h3>
  </vc-donut> -->
              <!-- <strong><i class="fa fa-file-text-o margin-r-5"></i> Notes</strong>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fermentum enim neque.</p> -->
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <!-- /.col -->
        <div class="col-md-9">
          <div class="box box-primary ">
            <div class="box-header">
              <div class="box-tools pull-right">
                <button type="button" @click="editForm()" class="btnbtn-xs" style="border: 0px;color: #5bad2b;"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="box-body box-profile">
                  <img @click="toggleShow" v-if="userInfo.profile_picture !='' && userInfo.profile_picture !=null" :src="`${userInfo.profile_picture}`" class="profile-user-img img-responsive img-circle">
                  <img @click="toggleShow" v-if="userInfo.profile_picture =='' || userInfo.profile_picture ==null" src="../../assets/img/org-default.png" class="profile-user-img img-responsive img-circle">
                  <i aria-hidden="true" @click="toggleShow" class="fa fa-pencil edit-icon"></i>
                </div>
              </div>
              <div class="col-md-9">
                <p class="text-muted" style="margin-bottom: 1px;">Organization name</p>
                <p><strong>{{userInfo.organization}}</strong></p>
                <p class="text-muted" style="margin-bottom: 1px;" v-if="form.orgwebsiteurl">Website</p>
                <p>{{form.orgwebsiteurl}}</p>
              </div>
            </div>
              <div class="box-body">
                <b-form class="register-form" v-on:submit.prevent="onSubmitProfile" novalidate style="background-color: #ffffff;padding: 20px;">

                <strong>Contact Details</strong>
                <hr>
                <div class="form-row">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Email ID</label>
                    <b-form-input readonly type="text" placeholder="email*" v-model.lazy.trim="$v.form.email.$model" :state="chkState('email')" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputmobile">Phone number</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Postal code*" v-model.lazy.trim="$v.form.mobile_number.$model" :state="chkState('mobile_number')" />
                  </div>
                </div>
                <strong>Organization Details</strong>
                <hr>
                <div class="form-row">
                  <div class="form-group">
                    <div class="form-select">
                      <label for="exampleInputEmail1">Organization type</label>
                      <select id="orgtype" :disabled="showtextbox" v-model.lazy.trim="$v.form.organization_type.$model" class="form-control" v-bind:class="{ 'is-invalid': !chkState('organization_type') }">
                        <!-- <option :value="form.organization_type">{{form.organization_type}}</option> -->
                        <option v-for="x in dropdown.skills" :key="x.skills" v-bind:value="x.designations">{{x.designations}}</option>
                      </select>
                      <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-select">
                      <label for="exampleInputEmail1">Organization size</label>
                      <select :disabled="showtextbox" v-model="form.organization_size" class="form-control" v-bind:class="{ 'is-invalid': !chkState('organization_size') }">
                        <option :value="form.organization_size">{{form.organization_size}}</option>
                        <option value="< 10"> {{asecond}} 10 </option>
                        <option value="11 to 50">11 to 50</option>
                        <option value="51 t0 200">51 to 200</option>
                        <option value="201 to 500">201 to 500</option>
                        <option value="501 to 1000">501 to 1000</option>
                        <option value="> 1000 ">> 1000 </option>
                      </select>
                      <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                    </div>
                  </div>
                </div>
                <strong>Location</strong>
                <hr>
                <div class="form-row">
                  <div class="form-group">
                    <div class="form-select">
                      <label for="exampleInputEmail1">Country</label>
                      <select :disabled="showtextbox" v-model.lazy.trim="$v.form.country.$model" @change="getState()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('country') }">
                        <option :value="form.country">{{form.country.name}}</option>
                        <option v-for="x in Country" :key="x.name" :value="x">{{x.name}}</option>
                      </select>
                      <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-select">
                      <label for="exampleInputEmail1">State</label>
                      <select :disabled="showtextbox" v-model="form.state" @change="getCity()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('state') }">
                        <option :value="form.state">{{form.state.name}}</option>
                        <option v-for="x in State" :value="x" :key="x.name">{{x.name}}</option>
                      </select>
                      <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Postal code</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Postal code*" v-model.lazy.trim="$v.form.postal_code.$model" :state="chkState('postal_code')" />
                  </div>
                </div>
                <strong>Timezone</strong>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <div class="col-md-10">
                      <div class="form-group">
                        <!-- <label for="exampleInputEmail1">Timezone</label> -->
                        <input :readonly="Boolean(showtextbox)" type="text" value="" class="form-control" id="exampleInputEmail1" placeholder="timezone">
                      </div>
                    </div>
                  </div>
                </div>
                <strong>Social Sites</strong>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <div class="col-md-10">
                      <div class="form-group">
                        <!-- <label for="exampleInputEmail1">Organization type</label> -->
                        <input :readonly="Boolean(showtextbox)" type="text" value="" class="form-control" id="exampleInputEmail1" placeholder="Social site">
                      </div>
                    </div>
                  </div>
                </div>
                <strong>Admin Details</strong>
                <hr>
                <div class="form-row">
                  <div class="form-group">
                    <label for="exampleInputEmail1">First name</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Enter your first name*" v-model.lazy.trim="$v.form.first_name.$model" :state="chkState('first_name')" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Last name</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Enter your Last name*" v-model.lazy.trim="$v.form.last_name.$model" :state="chkState('last_name')" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Designation</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Enter your designation*" v-model.lazy.trim="$v.form.designation.$model" :state="chkState('designation')" />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Secondary Mail address</label>
                    <b-form-input :readonly="Boolean(showtextbox)" type="text" placeholder="Enter your secondary email*" v-model.lazy.trim="$v.form.sec_mail_address.$model" :state="chkState('sec_mail_address')" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                  </div>
                  <div class="form-group" v-if="!showtextbox">
                  <button type="submit" class="btn btn-success btn-sm pull-right">Update</button>
                  </div>
                </div>
                </b-form>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
        <my-upload field="image"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :width="200"
        :height="200"
        :params="params"
        :headers="headers"
        lang-type="en"
        :noRotate="noRotate"
        :noSquare="noSquare"></my-upload>
    <!-- <img :src="imgDataUrl"> -->
        <!-- /.col -->
      </div>
</template>

<script>
// import Donut from 'vue-css-donut-chart'
import ICountry from 'country-state-city'
import { validationMixin } from 'vuelidate'
import { required, helpers, maxLength, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import myUpload from 'vue-image-crop-upload'
// import Vue from 'vue'
import $ from 'jquery'
// Vue.use(Donut)
const alpha = helpers.regex('alpha', /^[a-zA-Z]*$/)
const formShape = {
  _id: '',
  country: '',
  state: '',
  organization_size: '',
  organization_type: '',
  email: '',
  orgwebsiteurl: '',
  last_name: '',
  first_name: '',
  mobile_number: '',
  designation: '',
  sec_mail_address: '',
  postal_code: ''
}
export default {
  name: 'userprofile',
  components: {
    'my-upload': myUpload
  },
  data () {
    return {
      sections:
      [
        { label: 'Post', value: 75, color: '#B260EF' },
        { label: 'Scheduled', value: 10, color: ' #0077B5' },
        { label: 'Results', value: 10, color: 'green' },
        { label: 'Cancelled', value: 0, color: 'blue' }
      ],
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      form: Object.assign({}, formShape),
      showtextbox: true,
      dropdown: [],
      Country: ICountry.getAllCountries(),
      organizationSizeData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      OrganizationTypeData: ['IT', 'software', 'hardware'],
      State: '',
      City: '',
      noRotate: false,
      noSquare: true,
      afirst: '<',
      asecond: '<',
      urlupload: BaseURL + '/profile/upload',
      show: false,
      params: {
        token: '123456798',
        name: 'image',
        uid: 22
      },
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '',
      formdatas: []
    }
  },
  created () {
    this.getDatas()
    console.log(this.userInfo)
    this.form.country = {
      name: this.userInfo.country_name,
      id: this.userInfo.country_id,
      sortname: this.userInfo.country_sort_name,
      phonecode: this.userInfo.country_phone_code
    }
    this.form.state = {
      name: this.userInfo.state_name,
      id: this.userInfo.state_id
    }
    this.form.organization_size = this.userInfo.organization_size
    this.form.organization_type = this.userInfo.organization_type
    this.form.organization = this.userInfo.organization
    this.form.email = this.userInfo.user_email
    this.form.orgwebsiteurl = this.userInfo.orgwebsiteurl
    this.form.last_name = this.userInfo.last_name
    this.form.first_name = this.userInfo.first_name
    this.form.mobile_number = this.userInfo.mobile_number
    this.form.designation = this.userInfo.designation
    this.form._id = this.userInfo._id
    this.form.postal_code = this.userInfo.postal_code
    this.form.sec_mail_address = this.userInfo.sec_mail_address
    this.getState()
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      first_name: {
        required,
        alpha,
        maxLength: maxLength(15)
      },
      last_name: {
        required,
        alpha,
        maxLength: maxLength(15)
      },
      organization_type: {
        required
      },
      organization_size: {
        required
      },
      email: {

      },
      orgwebsiteurl: {

      },
      mobile_number: {

      },
      country: {
        required
      },
      state: {
        required
      },
      postal_code: {
        required
      },
      designation: {
        required
      },
      sec_mail_address: {
        required, email
      },
      _id: {
      }
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
      console.log('-------- crop success --------')
      this.imgDataUrl = imgDataUrl
      console.log(this.imgDataUrl)
      this.formdatas = []
      const formData = new FormData()
      formData.append('image', this.imgDataUrl)
      formData.append('uid', this.userInfo._id)
      this.formdatas = {
        image: this.imgDataUrl,
        uid: this.userInfo._id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      axios.post(BaseURL + '/profile/upload', { formData: this.formdatas }, config).then((response) => {
        this.userInfo = response.data.user_detail[0]
        localStorage.setItem('user__details', JSON.stringify(response.data.user_detail[0]))
        // router.push({name: 'Dashboard'})
      })
    },
    cropUploadSuccess (jsonData, field) {
      console.log('-------- upload success --------')
      console.log(jsonData)
      console.log('field: ' + field)
    },
    cropUploadFail (status, field) {
      console.log('-------- upload fail --------')
      console.log(status)
      console.log('field: ' + field)
    },
    getState () {
      console.log(this.form.country)
      this.State = ICountry.getStatesOfCountry(this.form.country.id)
    },
    getCity () {
      console.log(this.form.state)
      this.City = ICountry.getCitiesOfState(this.form.state.id)
      console.log(this.City)
    },
    getOrganization () {
      console.log(this.form.organizationStatus)
    },
    getDatas () {
      axios.get(`${BaseURL}/dropdown/list/of/designations/type`, this.config).then(response => {
        this.dropdown = response.data
        // response.data.skills.forEach(element => this.dropdown.push(element.organization_type));
      })
    },
    customLabel (option) {
      return `${option.library} - ${option.language}`
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    checkFormvalid () {
      console.log(this.form)
      if (this.form.organization) {
        console.log('success')
        this.step = 2
        this.$v.$reset()
      } else {
        console.log('error')
        this.$v.$touch()
      }
    },
    editForm () {
      console.log('check')
      this.showtextbox = false
    },
    onSubmitProfile () {
      if (this.form.organizationType !== '') {
        this.classname = 'form-control is-valid'
      } else {
        this.classname = 'form-control is-invalid'
      }
      if (this.validate()) {
        console.log(this.form)
        this.$nextTick(() => {
          this.form.organization_type = $('#orgtype option:selected').text()
          axios.post(BaseURL + '/profile/update_org_profile', {
            formData: this.form
          }, this.config).then(response => {
            console.log(response.data.userInfo)
            localStorage.setItem('user__details', JSON.stringify(response.data.userInfo))
            this.userInfo = response.data.userInfo
            this.$awn.success('Profile details updated successfully')
            this.showtextbox = true
          }).catch(e => {
            console.log(e)
          })
        })
      } else {
        console.log('validation fail................')
      }
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: 3px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
label {
  font-size: 12px;
  font-weight: inherit;
  color: #5b5b5b87;
}
.form-control {
    height: 40px;
    color: #3D3D3D !important;
    border: 1px solid #ccc !important;
}
.cdc-legend-item-color {
    height: 0.35em !important;
    width: 1.15em !important;
    border-radius: 2px;
    margin-right: .5em;
}
.over-len {
    display: block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.select-icon i {
  margin-top: 14px;
}
.is-invalid {
    border-color: #f86c6b !important;
}
.is-valid {
  /* border-color: #5bad2b !important; */
  border: 1px solid #ccc !important;
}
.toast-success {
    background-color: #5BAD2B !important;
}
.profile-user-img {
    margin: 0 auto;
    width: 100px;
    padding: 3px;
    border: 3px solid #d2d6de;
    height: 100px;
}
.vicp-img {
  left: -18.146px !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 36%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 13px;
}
</style>
